import React from 'react';
import PropTypes from 'prop-types';

const TreeLeaf = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 1.64453C23 1.76068 22.9919 4.52898 22.2924 8.02657C22.0431 9.27316 21.7361 10.4543 21.3761 11.5599L21.3702 11.5782C21.1362 12.2944 20.8801 12.9789 20.602 13.6278C20.2624 14.4202 19.8896 15.1609 19.4856 15.8479C19.4745 15.8687 19.4625 15.889 19.4492 15.9085C18.7951 17.0104 18.0603 17.9725 17.2507 18.782C15.6436 20.389 13.5071 21.2739 11.2343 21.2739C9.17783 21.2739 7.23282 20.5491 5.69081 19.2208L2.10023 22.8112C1.97452 22.9371 1.80952 23 1.64453 23C1.47954 23 1.31471 22.9371 1.18883 22.8112C0.937057 22.5596 0.937057 22.1515 1.18883 21.8998L4.77924 18.3092C3.45073 16.767 2.72597 14.822 2.72597 12.7655C2.72597 10.4929 3.61102 8.35638 5.21815 6.74925C6.02751 5.9399 6.98944 5.2049 8.09135 4.5508C8.11082 4.53754 8.13113 4.52545 8.15195 4.51437C8.83878 4.11037 9.57965 3.73758 10.3722 3.39786C11.0203 3.12024 11.7041 2.86427 12.4194 2.63063L12.4219 2.62978L12.422 2.62977C12.4285 2.62755 12.4349 2.62535 12.4416 2.62341C13.5467 2.26355 14.7273 1.95673 15.9734 1.70764C19.471 1.00806 22.2393 1 22.3555 1C22.5265 1 22.6903 1.06798 22.8112 1.18883C22.9322 1.30968 23 1.47366 23 1.64453ZM21.6923 2.30769C20.6757 2.35117 18.5962 2.49585 16.2014 2.97656C15.3017 3.15717 14.302 3.39803 13.2691 3.71643V9.8195L17.0181 6.07031C17.2699 5.81854 17.6779 5.81854 17.9297 6.07031C18.1813 6.32191 18.1813 6.73012 17.9297 6.98189L14.1803 10.7311L20.2836 10.7309C20.602 9.69798 20.8428 8.69829 21.0234 7.79863C21.5042 5.40396 21.6488 3.32451 21.6923 2.30769ZM18.539 14.9014H10.01L12.8913 12.0201L19.849 12.02C19.491 12.993 19.0595 13.9712 18.539 14.9014ZM11.98 11.1084V4.15099C11.0069 4.509 10.0288 4.94054 9.09843 5.46103L9.0986 13.9897L11.98 11.1084ZM4.01503 12.7655C4.01503 10.8373 4.76598 9.02441 6.12956 7.66083C6.64334 7.14705 7.20915 6.68346 7.80937 6.26518L7.80971 15.2787L5.69417 17.3944C4.60719 16.0981 4.01503 14.4774 4.01503 12.7655ZM11.2343 19.9848C13.1627 19.9848 14.9758 19.234 16.3393 17.8706C16.8531 17.3567 17.3167 16.7908 17.735 16.1905H8.72095L6.60558 18.3058C7.90186 19.3926 9.52258 19.9848 11.2343 19.9848Z"
      fill="#85B5BA"
    />
  </svg>
);

TreeLeaf.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

TreeLeaf.defaultProps = {
  width: 24,
  height: 24,
};

export default TreeLeaf;
